import i18n from 'i18n';

/**
 * Get default placeholder for a field type
 * Used by both candidate fields and field configs (client_fields, extra_result_details, configuration)
 */
export const getDefaultPlaceholder = (type, title, tFn = null) => {
  const t = tFn || i18n.t.bind(i18n);

  // Website fields
  if (type === 'website') {
    return t('common.websitePlaceholder');
  }

  // Select/multi_select fields (including region types: au_state, us_state, nz_region)
  if (
    type === 'select' ||
    type === 'multi_select' ||
    type === 'au_state' ||
    type === 'us_state' ||
    type === 'nz_region' ||
    type === 'multi_country' ||
    type === 'multi_country_alpha2' ||
    type === 'multi_country_alpha3' ||
    type === 'multi_au_state' ||
    type === 'multi_us_state' ||
    type === 'multi_nz_region'
  ) {
    return t('common.selectPlaceholder');
  }

  // Country types (single select)
  if (type === 'country' || type === 'country_alpha2' || type === 'country_alpha3') {
    return t('common.selectCountryPlaceholder');
  }

  // Email fields
  if (type === 'email') {
    return t('common.emailPlaceholder');
  }

  // Phone number fields
  if (type === 'phone_number') {
    return t('common.phoneNumber');
  }

  // Use title as placeholder for short_text if no placeholder provided
  if (type === 'short_text') {
    return title;
  }

  return undefined;
};
